import React from 'react';
import { IIconProps } from './utils';

export const Live = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 16 16" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M6.9987 11.3337H3.33203C2.22746 11.3337 1.33203 10.4382 1.33203 9.33366V4.66699C1.33203 3.56242 2.22746 2.66699 3.33203 2.66699H12.6654C13.7699 2.66699 14.6654 3.56242 14.6654 4.66699V9.33366C14.6654 10.4382 13.7699 11.3337 12.6654 11.3337H8.9987M6.9987 11.3337V13.3337M6.9987 11.3337H8.9987M6.9987 13.3337H4.66536M6.9987 13.3337H8.9987M11.332 13.3337H8.9987M8.9987 13.3337V11.3337" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33333" />
    <path d="M6.58203 8.63591V5.36409C6.58203 4.87904 7.11565 4.58608 7.5214 4.84837L10.052 6.48429C10.4254 6.72562 10.4254 7.27438 10.052 7.51571L7.5214 9.15163C7.11565 9.41392 6.58203 9.12097 6.58203 8.63591Z" fill={fill} />
  </svg>
);
